// extracted by mini-css-extract-plugin
export var browseStorie = "altitude-video-page-module--browse-storie--6d709";
export var description = "altitude-video-page-module--description--f2346";
export var detail1 = "altitude-video-page-module--detail-1--d00d3";
export var detail2 = "altitude-video-page-module--detail-2--142c8";
export var detail3 = "altitude-video-page-module--detail-3--63e9b";
export var details = "altitude-video-page-module--details--56d95";
export var head = "altitude-video-page-module--head--171d2";
export var section = "altitude-video-page-module--section--ac260";
export var share = "altitude-video-page-module--share--a67bc";
export var socialMedia = "altitude-video-page-module--socialMedia--84977";
export var speaker = "altitude-video-page-module--speaker--e08f7";
export var speakerContent = "altitude-video-page-module--speaker-content--8086a";
export var speakerImg = "altitude-video-page-module--speaker-img--abf9d";
export var transcript = "altitude-video-page-module--transcript--dcbf2";
export var video = "altitude-video-page-module--video--94121";